import React, { Component } from 'react'
import QuickSearchResult from './QuickSearchResult'
import { translate } from '../Services/translation'

class QuickSearch extends Component {
    focusOnInput() {
        setTimeout(() => {
            this.searchInput && this.searchInput.focus()
        }, 0)
    }

    render() {
        const {
            query,
            result,
            showResult,
            showFullForm,
            onSearch,
            onKeyDown,
            toggleShowFullForm,
            selectedItem,
            searchUrl,
        } = this.props
        return (
            <div className="quick-search" role="search">
                <a
                    className="quick-search__link--block"
                    onClick={(e) => {
                        toggleShowFullForm()
                        this.focusOnInput()
                    }}
                    title={translate('general.search')}
                >
                    <i className="quick-search__icon icon-search"></i>
                    <span className="quick-search__title">
                        {translate('general.search')}
                    </span>
                </a>
                <div
                    className={`quick-search__form ${
                        showFullForm ? 'quick-search__form--force-show' : ''
                    }`}
                    role="search"
                >
                    <input
                        className="quick-search__input"
                        type="text"
                        placeholder={translate('general.search')}
                        autoComplete="off"
                        value={query}
                        onChange={(event) => onSearch(event.target.value)}
                        onKeyDown={(event) => onKeyDown(event, { searchUrl })}
                        ref={(input) => {
                            this.searchInput = input
                        }}
                    />
                    <i
                        className="quick-search__icon icon-search"
                        onClick={(e) => toggleShowFullForm()}
                    ></i>
                    <button
                        className="quick-search__submit-button"
                        onClick={() => (location.href = searchUrl)}
                        type="submit"
                    >
                        <i className="quick-search__submit-icon"></i>
                        <span className="quick-search__submit-title">
                            {translate('general.searchbutton')}
                        </span>
                    </button>
                    {showResult && (
                        <QuickSearchResult
                            result={result}
                            selectedItem={selectedItem}
                            searchUrl={searchUrl}
                        />
                    )}
                </div>
            </div>
        )
    }
}

export default QuickSearch
